<ng-template #container></ng-template>
<div *ngIf="loadFailed" class="lazy-load-failure">
    <button class="btn-reload btn btn-sm btn-light" (click)="reload();">{{ 'APP.MAIN.ROOM.VIDEO_CHAT.COLLABORATION_SHARED.RELOAD' | translate }}</button>
</div>